import { enumify } from '../utils/enumify'

export const PROMPT_STATUSES = enumify(['pending', 'active', 'complete', 'stale', 'deleted'])
